<!--
/**
* @name: List.vue
* @description: 门店管理列表页
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item :class="css.inputW">
        <k-input placeholder="请输入门店编码" block clearable v-model="para.code"></k-input>
      </y-query-item>
      <y-query-item :class="css.inputW">
        <k-input placeholder="请输入门店名称" block clearable v-model="para.name"></k-input>
      </y-query-item>
      <y-query-item :class="css.inputW">
        <k-auto-complete block ref="au" :data="companyList" v-model="para.companyCode" key-field="code" value-field="name" search-field="name" layer-width="" placeholder="请选择推广公司">
          <div slot-scope="{ row }" :key="row.code" class="list">
            <span class="name">{{ row.name }}</span>
          </div>
        </k-auto-complete>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAddDealer">新建</y-button>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <!-- <y-query-item :class="css.inputW">
        <k-select placeholder="请选择销售渠道" block clearable v-model="para.channelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item :class="css.inputW">
        <k-select placeholder="请选择是否店中店" block clearable v-model="para.isShopInShop">
          <k-option :value="1" label="是">是</k-option>
          <k-option :value="2" label="否">否</k-option>
        </k-select>
      </y-query-item> -->
      <y-query-item :class="css.inputW">
        <k-select placeholder="请选择DSR" block clearable v-model="para.salesmanCode">
          <k-option v-for="item in DSRList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item :class="css.inputW">
        <k-input placeholder="请输入营业执照名称" block clearable v-model="para.businessLicenseName"></k-input>
      </y-query-item>
      <y-query-item :class="css.inputW">
        <k-input placeholder="请输入统一社会信用代码" block clearable v-model="para.businessLicenseCode"></k-input>
      </y-query-item>
    </y-query>
    <y-query :hasSearchButton="false">
      <!-- <y-query-item :class="css.inputW">
        <k-auto-complete
          ref="healthManAu"
          :data="healthManList"
          v-model="para.healthmanCode"
          key-field="code"
          value-field="name"
          search-field="name"
          layer-width=""
          placeholder="请选择营养顾问"
          block
          @focus="onFocus"
          @toggle="onToggle"
          @input="onInput"
          :empty="empty"
          :text="text"
        >
          <div slot-scope="{ row }" :key="row.code" class="list">
            <span class="name">{{ row.name }}</span>
          </div>
        </k-auto-complete>
      </y-query-item> -->
      <y-query-item :class="css.inputW">
        <k-input placeholder="请输入关联门店主账号" block clearable v-model="para.shopBossCode"></k-input>
      </y-query-item>
      <y-query-item :class="css.inputW">
        <k-select placeholder="请选择启停用状态" block clearable v-model="para.status">
          <k-option :value="1" label="启用">启用</k-option>
          <k-option :value="2" label="停用">停用</k-option>
        </k-select>
      </y-query-item>
      <y-query-item :class="css.inputW">
        <k-select placeholder="请选择审核状态" block clearable v-model="para.verifyStatus">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
    </y-query>
    <y-query :hasSearchButton="false">
      <y-query-item>
        <DatePicker :editable="false" type="datetimerange" @on-change="changeDate" :value="effectDate" format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择创建时间查询" style="width: 280px;"></DatePicker>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="dealersList" checkboxKey="code" @sort="onSort" :height="$root.tableHeightXXX" :rightFixedNumber="1"
             :columns="initColumns()"></k-table>
    <k-pagination v-if="dealersList && dealersList.length" :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize"
                  @page-change="onChangePageIndex" />
    <k-popup :show.sync="isShowVerifyPopup" title="请输入客商编码" @after-ok="verifyUp" v-loading="{loading:isLoading}">
      <y-popup-body size="mini">
        <y-form titleAlign="right" titleWidth="80px" contentWidth="100%">
          <y-form-item title="客商编码:" required>
            <k-input v-model="verifyPara.mainCustomerCode" clearable placeholder="请输入客商编码"></k-input>
          </y-form-item>
        </y-form>
      </y-popup-body>
    </k-popup>
    <!-- 编辑附加条件区域 start -->
    <!-- <div class="popup_box">
      <k-popup bind="v-if" okText="保存" title="附加信息编辑" :show.sync="isPopupShow" @after-ok="onSave">
        <div style="width: 650px;">
          <y-form titleAlign="right" titleWidth="100px" contentWidth="250px">
            <y-form-item title="门店名称：">
              <span>{{ editPara.name }}</span>
            </y-form-item>
            <y-form-item title="门店编码：">
              <span>{{ editPara.code }}</span>
            </y-form-item>
            <y-form-item title="营养顾问：">
              <k-auto-complete
                ref="au"
                :data="healthManList"
                v-model="editPara.healthManCode"
                key-field="code"
                value-field="name"
                search-field="name"
                layer-width=""
                placeholder="请选择营养顾问"
                @focus="onFocus"
                @toggle="onToggle"
                @input="onInput"
                :empty="empty"
                :text="text"
                block
              >
                <div slot-scope="{ row }" :key="row.code" class="list">
                  <span class="name">{{ row.name }}</span>
                </div>
              </k-auto-complete>
            </y-form-item>
            <y-form-item title="是否店中店：">
              <k-select placeholder="请选择" block clearable v-model="editPara.isShopInShop">
                <k-option value="2" label="否" :selected="editPara.isShopInShop == '2'">否</k-option>
              </k-select>
            </y-form-item>
            <y-form-item title="电销人员：">
              <k-auto-complete
                ref="bu"
                :data="telemarketingList"
                v-model="editPara.telemarketerCode"
                key-field="code"
                value-field="name"
                search-field="name"
                layer-width=""
                placeholder="请选择电销人员"
                @focus="onFocus"
                @toggle="onToggle"
                @input="onInput"
                :empty="empty"
                :text="text"
                block
              >
                <div slot-scope="{ row }" :key="row.code" class="list">
                  <span class="name">{{ row.name }}</span>
                </div>
              </k-auto-complete>
            </y-form-item>
          </y-form>
        </div>
      </k-popup>
    </div> -->
    <!-- 编辑附加条件区域 end -->
  </y-view>
</template>

<script>
import {
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_PAGELIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_STATUS_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_VERIFY
  // NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_APPEND_INFO,
  // NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_APPEND_INFO_UPDATE,
} from '@/assets/modules/apiList';

const initPara = () => ({
  code: '',
  name: '',
  companyCode: '',
  channelCode: '',
  isShopInShop: '',
  salesmanCode: '',
  healthmanCode: '',
  businessLicenseName: '',
  businessLicenseCode: '',
  shopBossCode: '',
  createTimeStart: '',
  createTimeEnd: '',
  status: '',
  verifyStatus: '',
  pageCurrent: 1,
  pageSize: 15
});
const initEditPara = () => ({
  name: '',
  code: '',
  healthManCode: '',
  shopGrade: '',
  telemarketerCode: '',
  isShopInShop: ''
});
export default {
  data() {
    return {
      createdTimeSorter: true,
      salemanList: [],
      DSRList: [],
      para: initPara(),
      editPara: initEditPara(),
      effectDate: '',
      companyList: [],
      channelList: [],
      statusList: [
        { value: 1, label: '未审核' },
        { value: 10, label: '已审核' }
      ],
      total: 0,
      isLoading: false,
      dealersList: [],
      // isPopupShow: false,
      healthManList: [],
      telemarketingList: [],
      shopGradeList: [],
      text: '',
      empty: '',
      verifyPara: {
        verifyStatus: '',
        code: '',
        mainCustomerCode: '',
        remitType: ''
      },
      isShowVerifyPopup: false
    };
  },
  watch: {},

  methods: {
    onFocus() {
    },
    onToggle(e) {
    },
    onInput(text) {
    },
    changeDate(date) {
      this.effectDate = date;
    },
    initColumns() {
      const createdTimeSorter = this.createdTimeSorter;
      return [
        {
          name: '门店编码',
          field: 'code',
          style: {
            width: 80,
            textAlign: 'center'
          }
        },
        {
          name: '门店名称',
          field: 'name',
          style: {
            width: 150,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        {
          name: '推广公司名称',
          field: 'companyName',
          style: {
            width: 120,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        {
          name: '关联门店主账号',
          field: 'shopBossAccount',
          style: {
            width: 120,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        // {
        //   name: "销售渠道",
        //   field: "channelName",
        //   style: {
        //     width: 120,
        //     textAlign: "center",
        //     "white-space": "normal",
        //     "line-height": "18px",
        //   },
        // },
        // {
        //   name: "是否店中店",
        //   field: "isShopInShop",
        //   style: {
        //     width: 80,
        //     textAlign: "center",
        //   },
        //   customRender: (row) => {
        //     const isShopInShopStr = row.isShopInShop == 1 ? <span>是</span> : <span>否</span>;
        //     return <div>{isShopInShopStr}</div>;
        //   },
        // },
        {
          name: '审核状态',
          field: 'verifyStatus',
          style: { textAlign: 'center' },
          customRender: (row) => {
            const verifyStatusStr = row.verifyStatus == 1 ? <span>未审核</span> : row.verifyStatus == 10 ? <span>已审核</span> :
              <span>审核失败</span>;
            return <div>{verifyStatusStr}</div>;
          }
        },
        {
          name: '状态',
          field: 'status',
          style: {
            width: 80,
            textAlign: 'center'
          },
          customRender: (row) => (
            <k-switch
              checked={row.status}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          )
        },
        {
          name: '创建时间',
          field: 'createTime',
          sorter: createdTimeSorter,
          style: { textAlign: 'center', width: 130 }
        },
        {
          name: '操作',
          field: 'action',
          style: {
            textAlign: 'center',
            width: 160
          },
          customRender: (row) => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            const previewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const onVerifyUpButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onVerifyUp(row);
                }}
              >
                审核
              </a>
            );
            const onVerifyDownwButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onVerifyDown(row);
                }}
              >
                反审核
              </a>
            );
            // const onEditAttachInfoButton = (
            //   <a
            //     href="javascript:void(0);"
            //     onClick={() => {
            //       this.onEditAttachInfo(row);
            //     }}
            //   >
            //     附加信息
            //   </a>
            // );
            if (row.verifyStatus == 1) {
              return (
                <div>
                  {editButton}&#12288;{onVerifyUpButton}
                </div>
              );
            } else if (row.verifyStatus == 10) {
              return (
                <div>
                  {previewButton}&#12288;{onVerifyDownwButton}
                </div>
              );
            } else {
              <div>
                {previewButton}&#12288;{onVerifyDownwButton}
              </div>;
            }
          }
        }
      ];
    },
    // onEditAttachInfo(row) {
    //   this.$fetch({
    //     api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_APPEND_INFO,
    //     para: {
    //       shopCode: row.code,
    //     },
    //   }).then((res) => {
    //     this.editPara.code = res.code;
    //     this.editPara.name = res.name;
    //     this.editPara.healthManCode = res.salesman ? res.salesman.salesmanCode : "";
    //     this.editPara.telemarketerCode = res.telemarketer ? res.telemarketer.salesmanCode : "";
    //     this.editPara.shopGrade = res.shopGrade;
    //   });
    //   this.isPopupShow = true;
    // },
    // onSave() {
    //   let { tip } = this.$root;
    //   let para = JSON.parse(JSON.stringify(this.editPara));
    //   this.$fetch({
    //     api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_APPEND_INFO_UPDATE,
    //     para: {
    //       code: para.code,
    //       healthManCode: para.healthManCode,
    //       isShopInShop: para.isShopInShop,
    //       telemarketerCode: para.telemarketerCode,
    //     },
    //   }).then((res) => {
    //     tip("修改成功");
    //     this.getDealersList();
    //     this.isPopupShow = false;
    //   });
    // },

    onSort({ type, field, name }) {
      type == 1 ? (this.para.orders = { asc: false, column: 'createTime' }) : (this.para.orders = { asc: true, column: 'createTime' });
      this.getDealersList();
    },
    onAddDealer() {
      this.$controller.open({
        name: 'dealerAdd',
        query: {
          refresh: new Date() - 0
        }
      });
    },
    onView(row) {
      const { code } = row;
      this.$controller.open({
        name: 'dealerAdd',
        query: {
          refresh: new Date() - 0,
          code,
          view: 1
        },
        title: '查看门店详情'
      });
    },
    onEdit(row) {
      const { code } = row;
      this.$controller.open({
        name: 'dealerAdd',
        query: {
          refresh: new Date() - 0,
          code,
          edit: 1
        },
        title: '编辑门店'
      });
    },
    getCompanyList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
        para: {}
      }).then((res) => {
        this.companyList = res || [];
      });
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {}
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    getSalemanList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_LIST,
        para: {}
      }).then((res) => {
        this.salemanList = res || [];
        this.DSRList = this.salemanList.filter((c) => c.type == 'sales01');
        this.healthManList = this.salemanList.filter((c) => c.type == 'sales02');
        this.telemarketingList = this.salemanList.filter((c) => c.type == 'sales03');
      });
    },
    getDealersList() {
      let { para } = this;
      para.createTimeStart = this.effectDate && this.effectDate.length > 0 ? this.effectDate[0] : '';
      para.createTimeEnd = this.effectDate && this.effectDate.length > 0 ? this.effectDate[1] : '';
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_PAGELIST,
        para
      }).then((res) => {
        this.dealersList = res.pageList || [];
        this.total = res.total;
      });
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getDealersList();
    },
    onChangeStatus(row) {
      let { code, status } = row;
      this.$dialog({
        title: '提示',
        content: `是否确认${row.status == '1' ? '停用' : '启用'}该门店？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_STATUS_UPDATE,
            para: { code, status: status == '1' ? 2 : 1 }
          })
            .then(() => {
              this.isLoading = false;
              this.getDealersList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    onVerifyUp(row) {
      this.verifyPara = this.$options.data().verifyPara;
      this.verifyPara.code = row.code;
      this.verifyPara.verifyStatus = 10;
      this.verifyPara.remitType = row.remitType;
      if (row.remitType == '2') {
        this.isShowVerifyPopup = true;
      } else {
        this.verifyUp();
      }
    },
    verifyUp() {
      if (this.verifyPara.remitType == '2' && !this.verifyPara.mainCustomerCode) {
        return this.$root.tip('请输入客商编码');
      }
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_VERIFY,
        para: this.verifyPara,
        isSuccessTip: true
      }).then((res) => {
        this.isLoading = false;
        this.getDealersList();
        (this.verifyPara.remitType == '2') && (this.isShowVerifyPopup = false);
      }).catch(() => {
        this.isLoading = false;
      })
    },
    onVerifyDown(row) {
      let { tip } = this.$root;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_VERIFY,
        para: { verifyStatus: 1, code: row.code }
      }).then((res) => {
        tip('反审核成功');
        this.getDealersList();
      });
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getDealersList();
    },
    onReset() {
      this.para = initPara();
      this.effectDate = '';
      // this.$refs.healthManAu.inputText = '';
      this.$refs.au.inputText = '';
      this.getDealersList();
    }
  },
  created() {
    this.getDealersList();
    this.getChannelList();
    this.getCompanyList();
    this.getSalemanList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getDealersList();
    next();
  }
};
</script>

<style lang="postcss" module="css">
.inputW {
  width: 280px;
}
</style>
<style>
.k-date-picker-range {
  width: 200px !important;
}
</style>
